export const wfxwMap = [
    {"value":"1001","label":"驾驶拼装的机动车上道路行驶的"},
    {"value":"1001A","label":"驾驶拼装的非汽车类机动车上道路行驶的"},
    {"value":"1002","label":"驾驶已达报废标准的车辆上道路行驶的"},
    {"value":"1003","label":"造成交通事故后逃逸，构成犯罪的"},
    {"value":"1004","label":"违反道路交通安全法律、法规的规定，发生重大事故，构成犯罪的"},
    {"value":"1005","label":"未取得驾驶证驾驶机动车"},
    {"value":"1006","label":"驾驶证被吊销期间驾驶机动车的"},
    {"value":"1007","label":"把机动车交给未取得机动车驾驶证的人驾驶的"},
    {"value":"1008","label":"把机动车交给机动车驾驶证被吊销的人驾驶的"},
    {"value":"1009","label":"把机动车交给机动车驾驶证被暂扣的人驾驶的"},
    {"value":"1010","label":"驾驶人在驾驶证超过有效期仍驾驶机动车的"},
    {"value":"1011","label":"非法安装警报器的"},
    {"value":"1012","label":"非法安装标志灯具"},
    {"value":"1013","label":"驾驶证丢失期间仍驾驶机动车的"},
    {"value":"1014","label":"驾驶证损毁期间仍驾驶机动车的"},
    {"value":"1015","label":"驾驶证被依法扣留期间仍驾驶机动车的"},
    {"value":"1016","label":"违法记分达到12分仍驾驶机动车的"},
    {"value":"1017","label":"不按规定投保机动车第三者责任险的"},
    {"value":"1018","label":"机动车不在机动车道内行驶的"},
    {"value":"1019","label":"机动车违反规定使用专用车道的"},
    {"value":"1020","label":"机动车驾驶人不服从交警指挥的"},
    {"value":"1021","label":"遇前方机动车停车排队等候或者缓慢行驶时，从前方车辆两侧穿插行驶的"},
    {"value":"1022","label":"遇前方机动车停车排队等候或者缓慢行驶时，从前方车辆两侧超越行驶的"},
    {"value":"1023","label":"遇前方机动车停车排队等候或者缓慢行驶时，未依次交替驶入车道减少后的路口、路段的"},
    {"value":"1024","label":"在没有交通信号灯、交通标志、交通标线或者交警指挥的交叉路口遇到停车排队等候或者缓慢行驶时，机动车未依次交替通行的"},
    {"value":"1025","label":"遇前方机动车停车排队等候或者缓慢行驶时，在人行横道、网状线区域内停车等候的"},
    {"value":"1026","label":"行经铁路道口，不按规定通行的"},
    {"value":"1027","label":"机动车载货长度、宽度、高度超过规定的"},
    {"value":"1028","label":"机动车载物行驶时遗洒、飘散载运物的"},
    {"value":"1029","label":"运载超限物品时不按规定的时间、路线、速度行驶的"},
    {"value":"1030","label":"运载超限物品时未悬挂明显标志的"},
    {"value":"1031","label":"运载危险物品未经批准的"},
    {"value":"1032","label":"运载危险物品时不按规定的时间、路线、速度行驶的"},
    {"value":"1033","label":"运载危险物品时未悬挂警示标志的"},
    {"value":"1034","label":"运载危险物品时未采取必要的安全措施的"},
    {"value":"1035","label":"载客汽车载货违反规定的"},
    {"value":"1036","label":"货运机动车违反规定载人的"},
    {"value":"1037","label":"未将故障车辆移到不妨碍交通的地方停放的"},
    {"value":"1038","label":"不避让正在作业的道路养护车、工程作业车的"},
    {"value":"1039","label":"机动车违反规定停放、临时停车，妨碍其它车辆、行人通行的"},
    {"value":"1039A","label":"机动车在道路上临时停车妨碍其它车辆、行人通行的，驾驶人不在现场或虽在现场但拒绝立即驶离的"},
    {"value":"1039B","label":"机动车违反规定停放、临时停车，妨碍其它车辆、行人通行的"},
    {"value":"1040","label":"机动车喷涂、粘贴标识或者车身广告影响安全驾驶的"},
    {"value":"1041","label":"道路养护施工作业车辆、机械作业时未开启示警灯和危险报警闪光灯的"},
    {"value":"1042","label":"机动车不按规定车道行驶的"},
    {"value":"1043","label":"变更车道时影响正常行驶的机动车的"},
    {"value":"1044","label":"在禁止掉头或者禁止左转弯标志、标线的地点掉头的"},
    {"value":"1045","label":"在容易发生危险的路段掉头的"},
    {"value":"1046","label":"掉头时妨碍正常行驶的车辆和行人通行的"},
    {"value":"1047","label":"机动车未按规定鸣喇叭示意的"},
    {"value":"1048","label":"在禁止鸣喇叭的区域或者路段鸣喇叭的"},
    {"value":"1049","label":"在机动车驾驶室的前后窗范围内悬挂、放置妨碍驾驶人视线的物品的"},
    {"value":"1050","label":"机动车行经漫水路或漫水桥时未低速通过的"},
    {"value":"1051","label":"机动车载运超限物品行经铁路道口时不按指定的道口通过的"},
    {"value":"1052","label":"机动车载运超限物品行经铁路道口时不按指定的时间通过的"},
    {"value":"1053","label":"机动车行经渡口，不服从渡口管理人员指挥，不依次待渡的"},
    {"value":"1054","label":"上下渡船时，不低速慢行的"},
    {"value":"1055","label":"特种车辆违反规定使用警报器的"},
    {"value":"1056","label":"特种车辆违反规定使用标志灯具的"},
    {"value":"1057","label":"机动车在单位院内居民居住区内不低速行驶的"},
    {"value":"1058","label":"机动车在单位院内居民居住区内不避让行人的"},
    {"value":"1059","label":"驾驶摩托车手离车把的"},
    {"value":"1060","label":"驾驶摩托车在车把上悬挂物品的"},
    {"value":"1061","label":"拖拉机驶入大中城市中心城区内道路的"},
    {"value":"1062","label":"拖拉机驶入高速公路、城市快速路或其它禁止通行道路的"},
    {"value":"1063","label":"拖拉机违反规定载人的"},
    {"value":"1064","label":"拖拉机牵引多辆挂车的"},
    {"value":"1065","label":"学习驾驶人不按指定路线上道路学习驾驶的"},
    {"value":"1066","label":"学习驾驶人不按指定时间上道路学习驾驶的"},
    {"value":"1067","label":"学习驾驶人使用非教练车上道路驾驶的"},
    {"value":"1068","label":"学习驾驶人在教练不随车指导下上道路驾驶车辆的"},
    {"value":"1069","label":"使用教练车时有与教学无关的人员乘坐的"},
    {"value":"1070","label":"实习期内未粘贴或悬挂实习标志的"},
    {"value":"1071","label":"上道路行驶的机动车未放置检验合格标志的"},
    {"value":"1072","label":"驾驶安全设施不全的机动车的"},
    {"value":"1073","label":"驾驶机件不符合技术标准的机动车的"},
    {"value":"1074","label":"不按规定倒车的"},
    {"value":"1075","label":"在车门、车厢没有关好时行车的"},
    {"value":"1076","label":"机动车在没有划分机动车道、非机动车道和人行道的道路上，不在道路中间通行的"},
    {"value":"1077","label":"驾驶机动车下陡坡时熄火、空档滑行的"},
    {"value":"1078","label":"机动车违反交通管制规定强行通行，不听劝阻的"},
    {"value":"1081","label":"除客运、危险物品运输车辆外，连续驾驶机动车超过4小时未停车休息或停车休息时间少于20分钟的"},
    {"value":"1082","label":"使用他人机动车驾驶证驾驶机动车的"},
    {"value":"1083","label":"载货汽车、挂车未按照规定安装侧面及后下部防护装置、粘贴车身反光标识的"},
    {"value":"1084","label":"改变车身颜色、更换发动机、车身或者车架，未按规定时限办理变更登记的"},
    {"value":"1085","label":"机动车所有权转移后，现机动车所有人未按规定时限办理转移登记的"},
    {"value":"1086","label":"机动车所有人办理变更登记、转移登记，机动车档案转出登记地车辆管理所后，未按照规定时限到住所地车辆管理所申请机动车转入的"},
    {"value":"1087","label":"擅自改变机动车外形和已登记的有关技术数据的"},
    {"value":"1088","label":"以欺骗、贿赂等不正当手段办理补、换领机动车登记证书、号牌、行驶证和检查合格标志等业务的"},
    {"value":"1089","label":"公路客运车辆违反规定载货的"},
    {"value":"1090","label":"机动车违反警告标志指示的"},
    {"value":"1091","label":"机动车违反警告标线指示的"},
    {"value":"1092","label":"公路客运车辆以外的载客汽车违反规定载货的"},
    {"value":"1093","label":"驾驶时观看电视的"},
    {"value":"1094","label":"在同车道行驶中，不按规定与前车保持必要的安全距离的"},
    {"value":"1095","label":"实习期内驾驶公共汽车的"},
    {"value":"1101","label":"驾驶人或者乘坐人员未按规定使用安全带的"},
    {"value":"1101A","label":"机动车驾驶人在乘坐人员未按规定使用安全带的情况下驾驶机动车的"},
    {"value":"1102","label":"不按规定使用灯光的"},
    {"value":"1103","label":"不按规定会车的"},
    {"value":"1104","label":"不按规定倒车的"},
    {"value":"1105","label":"摩托车后座乘坐不满十二周岁未成年人的"},
    {"value":"1106","label":"驾驶轻便摩托车载人的"},
    {"value":"1107","label":"在车门、车厢没有关好时行车的"},
    {"value":"1108","label":"上道路行驶的机动车未放置保险标志的"},
    {"value":"1109","label":"未随车携带行驶证的"},
    {"value":"1110","label":"未随车携带驾驶证的"},
    {"value":"1111","label":"机动车载货长度、宽度、高度超过规定的"},
    {"value":"1112","label":"机动车载物行驶时遗洒、飘散载运物的"},
    {"value":"1113","label":"运载超限物品时不按规定的时间、路线、速度行驶的"},
    {"value":"1114","label":"运载超限物品时未悬挂明显标志的"},
    {"value":"1115","label":"上路行驶的机动车未放置检验合格标志的"},
    {"value":"1201","label":"机动车载物超过核定载质量未达30%的"},
    {"value":"1202","label":"公路客运车辆载客超过核定载客人数未达20%的"},
    {"value":"1203","label":"机动车在没有划分机动车道、非机动车道和人行道的道路上，不在道路中间通行的"},
    {"value":"1204","label":"行经人行横道，未减速行驶的"},
    {"value":"1205","label":"遇行人正在通过人行横道时未停车让行的"},
    {"value":"1206","label":"行经没有交通信号的道路时，遇行人横过道路未避让的"},
    {"value":"1207","label":"驾驶摩托车时驾驶人未按规定戴安全头盔的或者乘坐人员未按规定戴安全头盔的"},
    {"value":"1208","label":"机动车通过有灯控路口时，不按所需行进方向驶入导向车道的"},
    {"value":"1209","label":"左转弯时，未靠路口中心点左侧转弯的"},
    {"value":"1210","label":"通过路口遇放行信号不依次通过的"},
    {"value":"1211","label":"通过路口遇停止信号时，停在停止线以内或路口内的"},
    {"value":"1212","label":"通过路口向右转弯遇同车道内有车等候放行信号时，不依次停车等候的"},
    {"value":"1213","label":"牵引故障机动车时，被牵引的机动车除驾驶人外载人的"},
    {"value":"1214","label":"牵引故障机动车时，被牵引的机动车拖带挂车的"},
    {"value":"1215","label":"牵引故障机动车时，被牵引的机动车宽度大于牵引的机动车的"},
    {"value":"1216","label":"使用软连接装置牵引故障机动车时，牵引车与被牵引车之间未保持安全距离的"},
    {"value":"1217","label":"牵引制动失效的被牵引车，未使用硬连接牵引装置的"},
    {"value":"1218","label":"使用汽车吊车牵引车辆的"},
    {"value":"1219","label":"使用轮式专用机械牵引车辆的"},
    {"value":"1220","label":"使用摩托车牵引车辆的"},
    {"value":"1221","label":"牵引摩托车的"},
    {"value":"1222","label":"未使用专用清障车拖曳转向或照明、信号装置失效的机动车的"},
    {"value":"1223","label":"驾驶时拨打接听手持电话的"},
    {"value":"1224","label":"驾驶时观看电视的"},
    {"value":"1225","label":"驾车时有其他妨碍安全行车的行为的"},
    {"value":"1226","label":"连续驾驶机动车超过4小时未停车休息或停车休息时间少于20分钟的"},
    {"value":"1227","label":"在同车道行驶中，不按规定与前车保持必要的安全距离的"},
    {"value":"1228","label":"路口遇有交通阻塞时未依次等候的"},
    {"value":"1229","label":"机动车违反禁令标志指示的"},
    {"value":"1230","label":"机动车违反禁止标线指示的"},
    {"value":"1231","label":"机动车违反警告标志指示的"},
    {"value":"1232","label":"机动车违反警告标线指示的"},
    {"value":"1233","label":"实习期内驾驶公共汽车的"},
    {"value":"1234","label":"实习期内驾驶营运客车的"},
    {"value":"1235","label":"实习期内驾驶执行任务的特种车辆的"},
    {"value":"1236","label":"实习期内驾驶载有危险物品的机动车的"},
    {"value":"1237","label":"实习期内驾驶的机动车牵引挂车的"},
    {"value":"1238","label":"机动车载人超过核定人数的"},
    {"value":"1239","label":"运输剧毒化学品机动车超过核定载质量未达30%的"},
    {"value":"1240","label":"驾驶人或者乘坐人员未按规定使用安全带的"},
    {"value":"1241","label":"驾驶公路客运车辆以外的载客汽车载人超过核定人数未达20%"},
    {"value":"1242","label":"公路客运车辆以外的载客汽车违反规定载货的"},
    {"value":"1243","label":"遇前方机动车停车排队或者缓慢行驶时，借道超车或者占用对面车道、穿插等候车辆的"},
    {"value":"1244","label":"在城市快速路上行驶时，驾驶人未按规定使用安全带的"},
    {"value":"1245","label":"不按照规定为校车配备安全设备的"},
    {"value":"1246","label":"不按照规定对校车进行安全维护的"},
    {"value":"1247","label":"驾驶校车运载学生，不按照规定放置校车标牌的"},
    {"value":"1248","label":"驾驶校车运载学生，不按照规定开启校车标志灯的"},
    {"value":"1249","label":"驾驶校车运载学生，不按照经审核确定线路行驶的"},
    {"value":"1250","label":"校车上下学生，不按照规定在校车停靠站点停靠的"},
    {"value":"1251","label":"校车未运载学生上道路行驶，使用校车标牌的"},
    {"value":"1252","label":"校车未运载学生上道路行驶，使用校车标志灯的"},
    {"value":"1253","label":"校车未运载学生上道路行驶，使用停车指示标志的"},
    {"value":"1254","label":"驾驶校车上道路行驶前，未对校车车况是否符合安全技术要求进行检查的"},
    {"value":"1255","label":"驾驶存在安全隐患的校车上道路行驶的"},
    {"value":"1256","label":"在校车载有学生时给车辆加油的"},
    {"value":"1257","label":"在校车发动机引擎熄灭前离开驾驶座位的"},
    {"value":"1301","label":"机动车逆向行驶的"},
    {"value":"1302","label":"机动车不按交通信号灯规定通行的"},
    {"value":"1302A","label":"机动车不按交通信号灯规定通行的"},
    {"value":"1303","label":"机动车行驶超过规定时速50%以下的"},
    {"value":"13031","label":"机动车行驶超过规定时速50%以下的"},
    {"value":"1304","label":"从前车右侧超车的"},
    {"value":"1305","label":"前车左转弯时超车的"},
    {"value":"1306","label":"前车掉头时超车的"},
    {"value":"1307","label":"前车超车时超车的"},
    {"value":"1308","label":"与对面来车有会车可能时超车的"},
    {"value":"1309","label":"超越执行紧急任务的警车、消防车、救护车、工程救险车的"},
    {"value":"1310","label":"在铁路道口、路口、窄桥、弯道、陡坡、隧道、人行横道、交通流量大的路段等地点超车的"},
    {"value":"1311","label":"车辆在道路上发生故障或事故后，妨碍交通又难以移动的，不按规定设置警告标志或未按规定使用警示灯光的"},
    {"value":"1312","label":"准备进入环形路口不让已在路口内的机动车先行的"},
    {"value":"1313","label":"转弯的机动车未让直行的车辆、行人先行的"},
    {"value":"1314","label":"相对方向行驶的右转弯机动车不让左转弯车辆先行的"},
    {"value":"1315","label":"机动车通过无灯控或交警指挥的路口，不按交通标志、标线指示让优先通行的一方先行的"},
    {"value":"1316","label":"机动车通过无灯控、交警指挥、交通标志标线控制的路口，不让右方道路的来车先行的"},
    {"value":"1317","label":"载货汽车牵引多辆挂车的"},
    {"value":"1318","label":"半挂牵引车牵引多辆挂车的"},
    {"value":"1319","label":"挂车的灯光信号、制动、连接、安全防护等装置不符合国家标准的"},
    {"value":"1320","label":"小型载客汽车牵引旅居挂车以外的且总质量700千克以上挂车的"},
    {"value":"1321","label":"挂车载人的"},
    {"value":"1322","label":"载货汽车牵引挂车的载质量超过汽车本身的载质量的"},
    {"value":"1323","label":"大型载客汽车牵引挂车的"},
    {"value":"1324","label":"中型载客汽车牵引挂车的"},
    {"value":"1325","label":"低速载货汽车牵引挂车的"},
    {"value":"1326","label":"三轮机动车汽车牵引挂车的"},
    {"value":"1327","label":"机动车在发生故障或事故后，不按规定使用灯光的"},
    {"value":"1328","label":"驾驶机动车下陡坡时熄火、空档滑行的"},
    {"value":"1329","label":"故意遮挡机动车号牌的"},
    {"value":"1330","label":"故意污损机动车号牌的"},
    {"value":"1331","label":"不按规定安装机动车号牌的"},
    {"value":"1332","label":"上道路行驶的机动车未悬挂机动车号牌的"},
    {"value":"1333","label":"不避让执行任务的特种车辆的"},
    {"value":"1334","label":"机动车不避让盲人的"},
    {"value":"1339","label":"运输剧毒化学品机动车超过规定时速50%以下的"},
    {"value":"1340","label":"上道路行驶的机动车未按规定定期进行安全技术检验的"},
    {"value":"1341","label":"驾驶公路客运车辆以外的载客汽车载人超过核定人数20%以上的"},
    {"value":"1342","label":"机动车载物超过核定载质量30％的"},
    {"value":"1343","label":"货运机动车违反规定载客的"},
    {"value":"1344","label":"机动车违反禁令标志指示的"},
    {"value":"1345","label":"机动车违反禁止标线指示的"},
    {"value":"1346","label":"运输剧毒化学品机动车超过核定载质量30％的"},
    {"value":"1348","label":"驾驶营运客车（不包括公共汽车）、校车以外的载客汽车载人超过核定人数未达20%的"},
    {"value":"1349","label":"驾驶中型以上载客汽车在高速公路、城市快速路以外的道路上行驶超过规定时速未达20%的"},
    {"value":"1350","label":"驾驶中型以上载货汽车在高速公路、城市快速路以外的道路上行驶超过规定时速未达20%的"},
    {"value":"1351","label":"驾驶危险物品运输车辆在高速公路、城市快速路以外的道路上行驶超过规定时速未达20%的"},
    {"value":"1352","label":"驾驶中型以上载客汽车、危险物品运输车辆以外的其他机动车行驶超过规定时速未达20%的"},
    {"value":"1353","label":"驾驶货车载物超过核定载质量未达30%的"},
    {"value":"1354","label":"驾驶危险物品运输车辆载物超过核定载质量未达30%的"},
    {"value":"1355","label":"驾驶机动车在城市快速路上不按规定车道行驶的"},
    {"value":"1356","label":"行经人行横道，未减速行驶的"},
    {"value":"1357","label":"遇行人正在通过人行横道时未停车让行的"},
    {"value":"1358","label":"行经没有交通信号的道路时，遇行人横过道路未避让的"},
    {"value":"1601","label":"公路客运车辆载客超过额定乘员20%"},
    {"value":"1601A","label":"公路客运车辆载客超过额定乘员20%的"},
    {"value":"1601B","label":"公路客运车辆载客超过额定乘员30%的"},
    {"value":"1601C","label":"公路客运车辆载客超过额定乘员40%的"},
    {"value":"1601D","label":"公路客运车辆载客超过额定乘员50%的"},
    {"value":"1601E","label":"公路客运车辆载客超过额定乘员60%的"},
    {"value":"1601F","label":"公路客运车辆载客超过额定乘员70%的"},
    {"value":"1601G","label":"公路客运车辆载客超过额定乘员80%的"},
    {"value":"1601H","label":"公路客运车辆载客超过额定乘员90%的"},
    {"value":"1602","label":"机动车载物超过核定载质量30%的"},
    {"value":"1603","label":"机动车行驶超过规定时速50%的"},
    {"value":"1603A","label":"机动车行驶超过规定时速50%的"},
    {"value":"1603B","label":"机动车行驶超过规定时速60%的"},
    {"value":"1603C","label":"机动车行驶超过规定时速70%的"},
    {"value":"1603D","label":"机动车行驶超过规定时速80%的"},
    {"value":"1603E","label":"机动车行驶超过规定时速90%以上的"},
    {"value":"1604","label":"饮酒后驾驶机动车的"},
    {"value":"1605","label":"饮酒后驾驶营运机动车的"},
    {"value":"1606","label":"公路客运车辆违反规定载货"},
    {"value":"1607","label":"货运机动车违反规定载客的"},
    {"value":"1608","label":"运输剧毒化学品机动车超过核定载质量30％的"},
    {"value":"1609","label":"运输剧毒化学品机动车超过规定时速50％的"},
    {"value":"1610","label":"在驾驶证暂扣期间仍驾驶机动车的"},
    {"value":"1611","label":"连续驾驶公路客运车辆超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"1612","label":"连续驾驶危险物品运输车辆超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"1613","label":"上道路行驶的机动车未悬挂机动车号牌"},
    {"value":"1614","label":"故意遮挡机动车号牌的"},
    {"value":"1615","label":"故意污损机动机车号牌的"},
    {"value":"1616","label":"不按规定安装机动车号牌的"},
    {"value":"1617","label":"运载危险物品时不按规定的时间、路线、速度行驶的"},
    {"value":"1618","label":"运载危险物品时未悬挂警示标志的"},
    {"value":"1619","label":"运载危险物品时未采取必要的安全措施的"},
    {"value":"1621","label":"公路客运车辆载客超过核定载客人数未达20%"},
    {"value":"1622","label":"机动车在城市快速路上遇交通拥堵，占用应急车道行驶的"},
    {"value":"1623","label":"校车载人超过核定人数未达20%的"},
    {"value":"1624","label":"机动车驾驶人不按照规定避让校车的"},
    {"value":"1625","label":"驾驶机动车违反道路交通信号灯通行的"},
    {"value":"1626","label":"驾驶公路客运车辆、公共汽车以外的其他营运客车载人超过核定人数未达20％的"},
    {"value":"1627","label":"驾驶营运客车（不包括公共汽车）以外的其他载客汽车载人超过核定人数20％以上的"},
    {"value":"1628","label":"驾驶中型以上载客汽车在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"1629","label":"驾驶中型以上载货汽车在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"1630","label":"驾驶校车在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"1631","label":"驾驶危险物品运输车辆在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"1632","label":"驾驶中型以上载客汽车在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到50%的"},
    {"value":"1633","label":"驾驶中型以上载货汽车在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到50%的"},
    {"value":"1634","label":"驾驶校车在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到50%的"},
    {"value":"1635","label":"驾驶危险物品运输车辆在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到50%的"},
    {"value":"1636","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的其他机动车行驶超过规定时速20%以上未达到50%的"},
    {"value":"1637","label":"驾驶货车载物超过核定载质量30%以上"},
    {"value":"1638","label":"驾驶货车违反规定载客的"},
    {"value":"1639","label":"危险物品运输车辆载物超过核定载质量30%以上"},
    {"value":"1640","label":"驾驶机动车运载超限的不可解体的物品，未按指定的时间、路线、速度行驶的"},
    {"value":"1641","label":"驾驶机动车运载超限的不可解体的物品，未悬挂明显标志的"},
    {"value":"1642","label":"连续驾驶中型以上载客汽车、危险物品运输车辆以外的机动车超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"1701","label":"使用他人机动车驾驶证驾驶机动车的"},
    {"value":"1702","label":"醉酒后驾驶机动车的"},
    {"value":"1703","label":"醉酒后驾驶营运机动车的"},
    {"value":"1704","label":"在驾驶证暂扣期间仍驾驶机动车的"},
    {"value":"1705","label":"造成交通事故后逃逸，尚不构成犯罪的"},
    {"value":"1706","label":"机动车违反交通管制规定强行通行，不听劝阻的"},
    {"value":"1707","label":"逾期3个月未缴纳罚款的"},
    {"value":"1708","label":"连续两次逾期未缴纳罚款的"},
    {"value":"1709","label":"驾驶与驾驶证载明的准驾车型不相符合的车辆"},
    {"value":"1710","label":"公路客运车辆载客超过额定乘员20%以上"},
    {"value":"1711","label":"饮酒后驾驶营运机动车的"},
    {"value":"1712","label":"饮酒后驾驶机动车的"},
    {"value":"1713","label":"因饮酒后驾驶机动车被处罚，再次饮酒后驾驶机动车的"},
    {"value":"1714","label":"校车载人超过核定人数20%以上的"},
    {"value":"1715","label":"驾驶人未取得校车驾驶资格驾驶校车的"},
    {"value":"1716","label":"驾驶公路客运车辆、公共汽车以外的其他营运客车载人超过核定人数20％以上的"},
    {"value":"1717","label":"上道路行驶的机动车未悬挂机动车号牌的"},
    {"value":"1718","label":"故意遮挡机动车号牌的"},
    {"value":"1719","label":"故意污损机动车号牌的"},
    {"value":"1720","label":"不按规定安装机动车号牌的"},
    {"value":"1721","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的机动车行驶超过规定时速50%以上的"},
    {"value":"1722","label":"驾驶中型以上载客汽车在城市快速路上行驶超过规定时速20％以上未达50%的"},
    {"value":"1723","label":"驾驶中型以上载货汽车在城市快速路上行驶超过规定时速20％以上未达50%的"},
    {"value":"1724","label":"驾驶校车在城市快速路上行驶超过规定时速20％以上未达50%的"},
    {"value":"1725","label":"驾驶危险物品运输车辆在城市快速路上行驶超过规定时速20％以上未达50%的"},
    {"value":"1726","label":"驾驶中型以上载客汽车在高速公路以外的道路上行驶超过规定时速50%的"},
    {"value":"1727","label":"驾驶中型以上载货汽车在高速公路以外的道路上行驶超过规定时速50%的"},
    {"value":"1728","label":"驾驶校车在高速公路以外的道路上行驶超过规定时速50%的"},
    {"value":"1729","label":"驾驶危险物品运输车辆在高速公路以外的道路上行驶超过规定时速50%的"},
    {"value":"1730","label":"连续驾驶中型以上载客汽车超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"1731","label":"连续驾驶危险物品运输车辆超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"2001","label":"非机动车造成交通事故后逃逸，尚不构成犯罪的"},
    {"value":"2002","label":"非机动车违反交通管制的规定强行通行，不听劝阻的"},
    {"value":"2003","label":"非机动车未依法登记，上道路行驶的"},
    {"value":"2004","label":"非机动车逆向行驶的"},
    {"value":"2005","label":"在没有非机动车道的道路上，非机动车不靠车行道右侧行驶的"},
    {"value":"2006","label":"非机动车违反规定使用其他车辆专用车道的"},
    {"value":"2007","label":"非机动车不按照交通信号规定通行的"},
    {"value":"2008","label":"非机动车驾驶人不服从交警指挥的"},
    {"value":"2009","label":"非机动车未在非机动车道内行驶的"},
    {"value":"2010","label":"醉酒驾驶、驾驭非机动车、畜力车的"},
    {"value":"2011","label":"驾驶残疾人机动轮椅车超速行驶的"},
    {"value":"2012","label":"驾驶电动自行车超速行驶的"},
    {"value":"2013","label":"非机动车不按规定载物的"},
    {"value":"2014","label":"非机动车不在规定地点停放的"},
    {"value":"2015","label":"非机动车停放时妨碍其他车辆和行人通行的"},
    {"value":"2016","label":"非机动车通过路口，转弯的非机动车不让直行的车辆、行人优先通行的"},
    {"value":"2017","label":"非机动车通过路口，遇有前方路口交通阻塞时，强行进入的"},
    {"value":"2018","label":"非机动车通过路口，向左转弯时，不靠路口中心点右侧转弯的"},
    {"value":"2019","label":"非机动车遇停止信号时，停在停止线以内或路口内的"},
    {"value":"2020","label":"非机动车向右转弯遇同车道内有车等候放行信号不能转弯时，不依次等候的"},
    {"value":"2021","label":"行经无灯控或交警指挥的路口，不让标志、标线指示优先通行的一方先行的"},
    {"value":"2022","label":"行经无灯控、交警指挥或标志、标线控制的路口，无交通标志标线，不让右方道路的来车先行的"},
    {"value":"2023","label":"行经无灯控或交警指挥的路口，右转弯的非机动车不让左转弯的车辆先行的"},
    {"value":"2024","label":"驾驶自行车、电动自行车、三轮车在路段上横过机动车道时不下车推行的"},
    {"value":"2025","label":"有人行横道时，非机动车不从人行横道横过机动车道的"},
    {"value":"2026","label":"有行人过街设施时，非机动车不从行人过街设施横过机动车道"},
    {"value":"2027","label":"非机动车借道行驶后不迅速驶回非机动车道的"},
    {"value":"2028","label":"非机动车转弯时未减速慢行，伸手示意，突然猛拐的"},
    {"value":"2029","label":"非机动车超车时妨碍被超越的车辆行驶的"},
    {"value":"2030","label":"驾驶非机动车牵引车辆的"},
    {"value":"2031","label":"驾驶非机动车攀扶车辆的"},
    {"value":"2032","label":"非机动车被其他车辆牵引的"},
    {"value":"2033","label":"驾驶非机动车时双手离把的"},
    {"value":"2034","label":"驾驶非机动车时手中持物的"},
    {"value":"2035","label":"驾驶非机动车时扶身并行的"},
    {"value":"2036","label":"驾驶非机动车时互相追逐的"},
    {"value":"2037","label":"驾驶非机动车时曲折竟驶的"},
    {"value":"2038","label":"在道路上骑独轮自行车的"},
    {"value":"2039","label":"在道路上骑2人以上骑行的自行车的"},
    {"value":"2040","label":"非下肢残疾的人驾驶残疾人机动轮椅车的"},
    {"value":"2041","label":"自行车加装动力装置的"},
    {"value":"2042","label":"三轮车加装动力装置的"},
    {"value":"2043","label":"在道路上学习驾驶非机动车的"},
    {"value":"2044","label":"非机动车不避让盲人的"},
    {"value":"2045","label":"驾驭畜力车横过道路时，驾驭人未下车牵引牲畜的"},
    {"value":"2046","label":"畜力车并行的"},
    {"value":"2047","label":"驾驶畜力车时驾驭人离开车辆的"},
    {"value":"2048","label":"驾驶畜力车时在容易发生危险的路段超车的"},
    {"value":"2049","label":"驾驶两轮畜力车不下车牵引牲畜的"},
    {"value":"2050","label":"使用未经驯服的牲畜驾车的"},
    {"value":"2051","label":"随车幼畜未栓系的"},
    {"value":"2052","label":"停放畜力车时未拉紧车闸的"},
    {"value":"2053","label":"停放畜力车时未栓系牲畜的"},
    {"value":"2054","label":"未满12周岁驾驶自行车、三轮车的"},
    {"value":"2055","label":"未满16周岁驾驶、驾驭电动自行车、残疾人机动轮椅、畜力车的"},
    {"value":"3001","label":"行人违反交通信号通行的"},
    {"value":"3002","label":"行人不服从交警指挥的"},
    {"value":"3003","label":"行人不在人行道内行走的"},
    {"value":"3004","label":"行人在没有划分机动车道、非机动车道和人行道的道路上，不靠路边行走的"},
    {"value":"3005","label":"行人横过道路未走人行横道或过街设施的"},
    {"value":"3006","label":"行人跨越道路隔离设施的"},
    {"value":"3007","label":"行人倚坐道路隔离设施的"},
    {"value":"3008","label":"行人扒车的"},
    {"value":"3009","label":"行人强行拦车的"},
    {"value":"3010","label":"行人实施其他妨碍交通安全的行为的"},
    {"value":"3011","label":"学龄前儿童以及不能辨认或不能控制自己行为的精神疾病患者、智力障碍者在道路上通行时，没有其监护人或对其负有管理职责的人带领的"},
    {"value":"3012","label":"盲人在道路上通行，未使用导盲手段的"},
    {"value":"3013","label":"行人不按规定通过铁路道口的"},
    {"value":"3014","label":"在道路上使用滑行工具的"},
    {"value":"3015","label":"行人在车行道内坐卧、停留、嬉闹的"},
    {"value":"3016","label":"行人有追车、抛物击车等妨碍道路交通安全的行为的"},
    {"value":"3017","label":"行人不按规定横过机动车道的"},
    {"value":"3018","label":"行人列队在道路上通行时每横列超过2人的"},
    {"value":"3019","label":"机动车行驶时，乘坐人员未按规定使用安全带的"},
    {"value":"3020","label":"乘坐摩托车不戴安全头盔的"},
    {"value":"3021","label":"乘车人携带易燃、易爆等危险物品的"},
    {"value":"3022","label":"乘车人向车外抛洒物品的"},
    {"value":"3023","label":"乘车人有影响驾驶人安全驾驶的行为的"},
    {"value":"3024","label":"在机动车道上拦乘机动车的"},
    {"value":"3025","label":"在机动车道上从机动车左侧上下车的"},
    {"value":"3026","label":"开关车门妨碍其他车辆和行人通行的"},
    {"value":"3027","label":"机动车行驶中乘坐人员干扰驾驶的"},
    {"value":"3028","label":"机动车行驶中乘坐人员将身体任何部分伸出车外的"},
    {"value":"3029","label":"乘车人在机动车行驶中跳车的"},
    {"value":"3030","label":"乘坐两轮摩托车未正向骑坐的"},
    {"value":"4001","label":"行人进入高速公路的"},
    {"value":"4002","label":"拖拉机驶入高速公路的"},
    {"value":"4003","label":"非机动车驶入高速公路"},
    {"value":"4004","label":"在高速公路上车辆发生故障或事故后，车上人员未迅速转移到右侧路肩上或者应急车道内的"},
    {"value":"4005","label":"机动车从匝道进入或驶离高速公路时不按规定使用灯光的"},
    {"value":"4006","label":"机动车从匝道进入高速公路时妨碍已在高速公路内的机动车正常行驶的"},
    {"value":"4007","label":"在高速公路的路肩上行驶的"},
    {"value":"4008","label":"非紧急情况下在高速公路应急车道上行驶的"},
    {"value":"4009","label":"机动车在高速公路上通过施工作业路段，不减速行驶的"},
    {"value":"4010","label":"在高速公路上骑、轧车行道分界线的"},
    {"value":"4011","label":"在高速公路上试车或学习驾驶机动车的"},
    {"value":"4012","label":"在高速公路上违反规定拖曳故障车、肇事车的"},
    {"value":"4013","label":"低能见度气象条件下在高速公路上不按规定行驶的"},
    {"value":"4014","label":"在高速公路上行驶的载货汽车车厢载人的"},
    {"value":"4015","label":"在高速公路上行驶的两轮摩托车载人的"},
    {"value":"4201","label":"在高速公路匝道上超车的"},
    {"value":"4202","label":"在高速公路加速车道上超车的"},
    {"value":"4203","label":"在高速公路减速车道上超车的"},
    {"value":"4204","label":"在高速公路上行驶时，驾驶人未按规定使用安全带的"},
    {"value":"4301","label":"驾驶设计最高时速低于70公里的机动车进入高速公路的"},
    {"value":"4302","label":"机动车在高速公路上发生故障或交通事故后，驾驶人不按规定使用危险报警闪光灯的"},
    {"value":"4303","label":"高速公路上车辆发生故障或交通事故后，不按规定设置警告标志的"},
    {"value":"4304","label":"在高速公路上违反规定拖曳故障车、肇事车的"},
    {"value":"4305","label":"在高速公路上超速不足50%的"},
    {"value":"4306","label":"在高速公路上正常情况下以低于规定最低时速行驶的"},
    {"value":"4307","label":"低能见度气象条件下在高速公路上不按规定行驶的"},
    {"value":"4308","label":"在高速公路上骑、轧车行道分界线的"},
    {"value":"4309","label":"在高速公路上行驶的载货汽车车厢载人的"},
    {"value":"4310","label":"在高速公路上行驶的两轮摩托车载人的"},
    {"value":"4311","label":"在高速公路上不按规定超车的"},
    {"value":"4312","label":"驾驶机动车在高速公路上不按规定车道行驶的"},
    {"value":"4601","label":"在高速公路上倒车的"},
    {"value":"4602","label":"在高速公路上逆行的"},
    {"value":"4603","label":"在高速公路上穿越中央分隔带掉头的"},
    {"value":"4604","label":"在高速公路上的车道内停车的"},
    {"value":"4605","label":"非紧急情况下在高速公路应急车道上停车的"},
    {"value":"4606","label":"在高速公路上试车或学习驾驶机动车的"},
    {"value":"4607","label":"在高速公路行车道上停车的"},
    {"value":"4608","label":"机动车在高速公路遇交通拥堵，占用应急车道行驶的"},
    {"value":"4609","label":"驾驶中型以上载客汽车在高速公路上行驶超过规定时速未达20％的"},
    {"value":"4610","label":"驾驶中型以上载货汽车在高速公路上行驶超过规定时速未达20％的"},
    {"value":"4611","label":"驾驶校车在高速公路上行驶超过规定时速未达20％的"},
    {"value":"4612","label":"驾驶危险物品运输车辆在高速公路上行驶超过规定时速未达20％的"},
    {"value":"4613","label":"驾驶营运客车以外的机动车在高速公路行车道上停车的"},
    {"value":"4614","label":"驾驶营运客车以外的机动车非紧急情况下在高速公路应急车道上停车的"},
    {"value":"4615","label":"低能见度气象条件下，驾驶机动车在高速公路上不按规定行驶的"},
    {"value":"4701","label":"在高速公路上倒车的"},
    {"value":"4702","label":"在高速公路上逆行的"},
    {"value":"4703","label":"在高速公路上穿越中央分隔带掉头的"},
    {"value":"4704","label":"驾驶营运客车在高速公路行车道上停车的"},
    {"value":"4705","label":"驾驶营运客车非紧急情况下在高速公路应急车道上停车的"},
    {"value":"4706","label":"驾驶中型以上载客汽车在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"4707","label":"驾驶中型以上载货汽车在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"4708","label":"驾驶校车在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"4709","label":"驾驶危险物品运输车辆在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"4710","label":"驾驶中型以上载客汽车在高速公路上行驶超过规定时速50%的"},
    {"value":"4711","label":"驾驶中型以上载货汽车在高速公路上行驶超过规定时速50%的"},
    {"value":"4712","label":"驾驶校车在高速公路上行驶超过规定时速50%的"},
    {"value":"4713","label":"驾驶危险物品运输车辆在高速公路上行驶超过规定时速50%的"},
    {"value":"5001","label":"伪造、变造机动车登记证书的"},
    {"value":"5002","label":"伪造、变造机动车号牌的"},
    {"value":"5003","label":"伪造、变造机动车行驶证的"},
    {"value":"5004","label":"伪造、变造机动车检验合格标志的"},
    {"value":"5005","label":"伪造、变造机动车保险标志的"},
    {"value":"5006","label":"伪造、变造机动车驾驶证的"},
    {"value":"5007","label":"使用伪造、变造的机动车登记证书的"},
    {"value":"5008","label":"使用伪造、变造的机动车号牌"},
    {"value":"5009","label":"使用伪造、变造的机动车行驶证"},
    {"value":"5010","label":"使用伪造、变造的机动车检验合格标志的"},
    {"value":"5011","label":"使用伪造、变造的机动车保险标志的"},
    {"value":"5012","label":"使用伪造、变造的机动车驾驶证"},
    {"value":"5013","label":"使用其他车辆的机动车登记证书的"},
    {"value":"5014","label":"使用其他车辆的机动车号牌的"},
    {"value":"5015","label":"使用其他车辆的机动车行驶证的"},
    {"value":"5016","label":"使用其他车辆的机动车检验合格标志的"},
    {"value":"5017","label":"使用其他车辆的机动车保险标志的"},
    {"value":"5018","label":"强迫驾驶人违反交通安全法律、法规和安全驾驶要求驾驶机动车，造成交通事故但尚不构成犯罪的"},
    {"value":"5019","label":"故意损毁交通设施，造成危害后果，尚不构成犯罪的"},
    {"value":"5020","label":"故意移动交通设施，造成危害后果，尚不构成犯罪的"},
    {"value":"5021","label":"故意涂改交通设施，造成危害后果，尚不构成犯罪的"},
    {"value":"5022","label":"非法拦载机动车，不听劝阻，造成交通严重阻塞、较大财产损失的"},
    {"value":"5023","label":"非法扣留机动车辆，不听劝阻，造成交通严重阻塞、较大财产损失的"},
    {"value":"5024","label":"道路两侧及隔离带上种植物或设置广告牌、管线等，遮挡路灯、交通信号灯、交通标志，妨碍安全视距拒不排除障碍的"},
    {"value":"5025","label":"道路两侧及隔离带上种植物或设置广告牌、管线等，遮挡路灯、交通信号灯、交通标志，妨碍安全视距的"},
    {"value":"5026","label":"擅自挖掘道路影响交通安全的"},
    {"value":"5027","label":"擅自占用道路施工影响交通安全的"},
    {"value":"5028","label":"从事其他影响交通安全活动的"},
    {"value":"5029","label":"出售已达到报废标准的机动车的"},
    {"value":"5030","label":"其他机动车喷涂特种车特定标志图案的"},
    {"value":"5031","label":"生产拼装机动车的"},
    {"value":"5032","label":"生产擅自改装的机动车的"},
    {"value":"5033","label":"销售拼装机动车的"},
    {"value":"5034","label":"销售擅自改装的机动车的"},
    {"value":"5035","label":"服用国家管制的精神药品或麻醉药品仍继续驾驶的"},
    {"value":"5036","label":"患有妨碍安全驾驶机动车的疾病仍继续驾驶的"},
    {"value":"5037","label":"过度疲劳仍继续驾驶的"},
    {"value":"5038","label":"重型、中型载货汽车及其挂车的车身或者车厢后部未按照规定喷涂放大的牌号或者放大的牌号不清晰的"},
    {"value":"5039","label":"对符合暂扣和吊销机动车驾驶证情形，机动车驾驶证被扣留后驾驶人无正当理由逾期未接受处理的"},
    {"value":"5040","label":"以欺骗、贿赂手段取得机动车牌证的"},
    {"value":"5041","label":"以欺骗、贿赂手段取得驾驶证的"},
    {"value":"5042","label":"12个月内累积记分达到12分拒不参加学习也不接受考试的"},
    {"value":"5043","label":"车辆被扣留后，经公告三个月后仍不来接受处理的"},
    {"value":"5044","label":"机动车安全技术检验机构出具虚假检验结果的"},
    {"value":"5045","label":"擅自停止使用停车场或改作他用的"},
    {"value":"5046","label":"运输单位的客运车辆载客或货运车辆超载，经处罚不改的(对直接负责的主管人员)"},
    {"value":"5047","label":"改变机动车型号、发动机号、车架号或者车辆识别代号的"},
    {"value":"5048","label":"未经许可，占用道路从事非交通活动的"},
    {"value":"5049","label":"1年内醉酒后驾驶机动车被处罚两次以上的"},
    {"value":"5050","label":"车辆所有人使用拼装的机动车接送学生的"},
    {"value":"5051","label":"车辆所有人使用达到报废标准的机动车接送学生的"},
    {"value":"5052","label":"使用未取得校车标牌的车辆提供校车服务的"},
    {"value":"5053","label":"使用未取得校车驾驶资格的人员驾驶校车的"},
    {"value":"5054","label":"伪造、变造校车标牌的"},
    {"value":"5055","label":"未按照规定指派照管人员随校车全程照管乘车学生的"},
    {"value":"5056","label":"在一个记分周期内累积记分达到十二分的"},
    {"value":"5601","label":"使用伪造、变造的机动车号牌"},
    {"value":"5602","label":"使用其他车辆的机动车号牌"},
    {"value":"5603","label":"以隐瞒、欺骗手段补领机动车驾驶证的"},
    {"value":"5701","label":"使用伪造、变造的机动车号牌的"},
    {"value":"5702","label":"使用伪造、变造的机动车行驶证的"},
    {"value":"5703","label":"使用伪造、变造的机动车驾驶证的"},
    {"value":"5704","label":"使用其他车辆的机动车号牌的"},
    {"value":"5705","label":"使用其他车辆的机动车行驶证的"},
    {"value":"5706","label":"使用伪造、变造的校车标牌的"},
    {"value":"6001","label":"牵引故障机动车时，被牵引的机动车除驾驶人外载人的"},
    {"value":"6002","label":"牵引故障机动车时，被牵引的机动车拖带挂车的"},
    {"value":"6003","label":"牵引故障机动车时，被牵引的机动车宽度大于牵引的机动车的"},
    {"value":"6004","label":"使用软连接装置牵引故障机动车时，牵引车与被牵引车之间未保持安全距离的"},
    {"value":"6005","label":"牵引制动失效的被牵引车，未使用硬连接牵引装置的"},
    {"value":"6006","label":"使用汽车吊车牵引车辆的"},
    {"value":"6007","label":"使用轮式专用机械牵引车辆的"},
    {"value":"6008","label":"使用摩托车牵引车辆的"},
    {"value":"6009","label":"牵引摩托车的"},
    {"value":"6010","label":"未使用专用清障车拖曳转向或照明、信号装置失效的机动车的"},
    {"value":"6011","label":"在高速公路或城市快速路以外的道路上行驶时，驾驶人未按规定使用安全带的"},
    {"value":"6012","label":"摩托车后座乘坐不满十二周岁未成年人的"},
    {"value":"6013","label":"驾驶轻便摩托车载人的"},
    {"value":"6014","label":"机动车载物行驶时遗洒、飘散载运物的"},
    {"value":"6015","label":"运载超限物品时不按规定的时间、路线、速度行驶的"},
    {"value":"6016","label":"运载超限物品时未悬挂明显标志的"},
    {"value":"6017","label":"驾驶载客汽车以外的其他机动车载人超过核定人数的"},
    {"value":"6018","label":"补领机动车驾驶证后，继续使用原机动车驾驶证的"},
    {"value":"6019","label":"发生交通事故后，应当自行撤离现场而未撤离，造成交通堵塞的"},
    {"value":"6020","label":"驾驶拼装的机动车接送学生的"},
    {"value":"6021","label":"驾驶达到报废标准的机动车接送学生的"},
    {"value":"6022","label":"饮酒后或者醉酒驾驶机动车发生重大交通事故，构成犯罪的"},
    {"value":"6023","label":"驾驶机动车在高速公路、城市快速路以外的道路上不按规定车道行驶的"},
    {"value":"6024","label":"机动车驾驶人在实习期内驾驶公共汽车、营运客车或者执行任务的警车、消防车、救护车、工程救险车以及载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车的"},
    {"value":"6025","label":"机动车驾驶人在实习期内驾驶牵引挂车的"},
    {"value":"6026","label":"机动车驾驶人在实习期内驾驶机动车上高速公路行驶，无相应或者更高准驾车型驾驶证三年以上的驾驶人陪同的"},
    {"value":"6027","label":"驾驶机动车未按规定粘贴、悬挂实习标志的"},
    {"value":"6028","label":"驾驶机动车未按规定粘贴、悬挂残疾人机动车专用标志的"},
    {"value":"6029","label":"持有大型客车、牵引车、城市公交车、中型客车、大型货车驾驶证的驾驶人，未按照规定申报变更信息的"},
    {"value":"6030","label":"机动车驾驶人身体条件发生变化不适合驾驶机动车，仍驾驶机动车的"},
    {"value":"6031","label":"逾期不参加审验的"},
    {"value":"6032","label":"醉酒后驾驶机动车的"},
    {"value":"6033","label":"醉酒后驾驶营运机动车的"},
    {"value":"6034","label":"饮酒后驾驶营运机动车的"},
    {"value":"6035","label":"因饮酒后驾驶机动车被处罚，再次饮酒后驾驶机动车的"},
    {"value":"6036","label":"挂车的灯光信号、制动、连接、安全防护等装置不符合国家标准的"},
    {"value":"6037","label":"挂车载人的"},
    {"value":"6038","label":"货运机动车驾驶室载人超过核定人数的"},
    {"value":"7001","label":"行人不给执行紧急任务的警车、消防车、救护车、工程救险车让行的"},
    {"value":"7002","label":"非机动车驾驶人不避让正在作业的道路养护车、工程作业车的"},
    {"value":"7003","label":"骑自行车、电动自行车违反规定带人的"},
    {"value":"7004","label":"违反非机动车限制通行、禁止通行规定的"},
    {"value":"7005","label":"非机动车不给执行紧急任务的警车、消防车、救护车、工程救险车让行的"},
    {"value":"7006","label":"违反分道行驶规定的"},
    {"value":"7007","label":"不按法律、法规规定驶入或者驶离高速公路的"},
    {"value":"7008","label":"机动车在高速公路、城市快速路上发生故障难以移动时，乘车人不按规定转移到安全地点的"},
    {"value":"7009","label":"非机动车制动器失效，仍在道路上驾驶的"},
    {"value":"7010","label":"设有转向灯的非机动车，转弯前未开启专向灯的"},
    {"value":"7011","label":"非机动车牵引动物的"},
    {"value":"7012","label":"驾驶非机动车时以手持方式使用电话的"},
    {"value":"7013","label":"非机动车驾驶人横过机动车道不按法律、法规规定通行的"},
    {"value":"7014","label":"乘车人在高速公路上不按规定使用安全带的"},
    {"value":"7015","label":"接送中小学生、幼儿的车辆未按规定喷涂统一标识或者放置标牌的"},
    {"value":"7016","label":"摩托车载人超过核定人数的"},
    {"value":"7017","label":"不按规定办理机动车登记的"},
    {"value":"7018","label":"在机动车上安装影响交通技术监控信息接收的装置的"},
    {"value":"7019","label":"驾驶擅自改变结构等不符合登记内容的机动车的"},
    {"value":"7020","label":"机动车在高速公路上遇交通阻塞停车时，车上人员在行驶车道内活动、逗留的"},
    {"value":"7021","label":"机动车在高速公路上遇交通阻塞停车时，驾驶人在夜间未开启危险报警闪光灯、示廓灯和前后位灯"},
    {"value":"7301","label":"机动车在道路上发生故障或事故,不按法律、法规规定处置的"},
    {"value":"7302","label":"在高速公路上超速20%以上50%以下"},
    {"value":"7303","label":"在高速公路上超过规定时速50%以上的"},
    {"value":"7304","label":"在高速公路上中型以上客车、货车、危险品运输车超速20%以下"},
    {"value":"10011","label":"驾驶拼装的机动车上道路行驶的"},
    {"value":"10012","label":"驾驶拼装的机动车上道路行驶的"},
    {"value":"10013","label":"驾驶拼装的机动车上道路行驶的"},
    {"value":"10014","label":"驾驶拼装的机动车上道路行驶的"},
    {"value":"10021","label":"驾驶已达报废标准的机动车上道路行驶的"},
    {"value":"10022","label":"驾驶已达报废标准的机动车上道路行驶的"},
    {"value":"10023","label":"驾驶已达报废标准的机动车上道路行驶的"},
    {"value":"10024","label":"驾驶已达报废标准的机动车上道路行驶的"},
    {"value":"10030","label":"造成交通事故后逃逸，构成犯罪的"},
    {"value":"10040","label":"违反道路交通安全法律、法规的规定，发生重大事故，构成犯罪的"},
    {"value":"10051","label":"未取得驾驶证驾驶机动车的"},
    {"value":"10052","label":"未取得驾驶证驾驶机动车的"},
    {"value":"10053","label":"未取得驾驶证驾驶机动车的"},
    {"value":"10054","label":"未取得驾驶证驾驶机动车的"},
    {"value":"10061","label":"驾驶证被吊销期间驾驶机动车的"},
    {"value":"10062","label":"驾驶证被吊销期间驾驶机动车的"},
    {"value":"10063","label":"驾驶证被吊销期间驾驶机动车的"},
    {"value":"10064","label":"驾驶证被吊销期间驾驶机动车的"},
    {"value":"10071","label":"把机动车交给未取得机动车驾驶证的人驾驶的"},
    {"value":"10072","label":"把机动车交给未取得机动车驾驶证的人驾驶的"},
    {"value":"10073","label":"把机动车交给未取得机动车驾驶证的人驾驶的"},
    {"value":"10074","label":"把机动车交给未取得机动车驾驶证的人驾驶的"},
    {"value":"10081","label":"把机动车交给机动车驾驶证被吊销的人驾驶的"},
    {"value":"10082","label":"把机动车交给机动车驾驶证被吊销的人驾驶的"},
    {"value":"10083","label":"把机动车交给机动车驾驶证被吊销的人驾驶的"},
    {"value":"10084","label":"把机动车交给机动车驾驶证被吊销的人驾驶的"},
    {"value":"10091","label":"把机动车交给机动车驾驶证被暂扣的人驾驶的"},
    {"value":"10092","label":"把机动车交给机动车驾驶证被暂扣的人驾驶的"},
    {"value":"10093","label":"把机动车交给机动车驾驶证被暂扣的人驾驶的"},
    {"value":"10094","label":"把机动车交给机动车驾驶证被暂扣的人驾驶的"},
    {"value":"10100","label":"驾驶人在驾驶证超过有效期仍驾驶机动车的"},
    {"value":"10110","label":"非法安装警报器的"},
    {"value":"10120","label":"非法安装标志灯具的"},
    {"value":"10130","label":"驾驶证丢失期间仍驾驶机动车的"},
    {"value":"10140","label":"驾驶证损毁期间仍驾驶机动车的"},
    {"value":"10150","label":"驾驶证被依法扣留期间仍驾驶机动车的"},
    {"value":"10160","label":"违法记分达到12分仍驾驶机动车的"},
    {"value":"10170","label":"不按规定投保机动车第三者责任强制保险的"},
    {"value":"10180","label":"机动车不在机动车道内行驶的"},
    {"value":"10190","label":"机动车违反规定使用专用车道的"},
    {"value":"10200","label":"机动车驾驶人不服从交警指挥的"},
    {"value":"10230","label":"遇前方机动车停车排队等候或者缓慢行驶时，未依次交替驶入车道减少后的路口、路段的"},
    {"value":"10240","label":"在没有交通信号灯、交通标志、交通标线或者交警指挥的交叉路口遇到停车排队等候或者缓慢行驶时，机动车未依次交替通行的"},
    {"value":"10250","label":"遇前方机动车停车排队等候或者缓慢行驶时，在人行横道、网状线区域内停车等候的"},
    {"value":"10260","label":"行经铁路道口，不按规定通行的"},
    {"value":"10310","label":"运载危险物品未经批准的"},
    {"value":"10350","label":"客运机动车违反规定载货的"},
    {"value":"10360","label":"货运机动车违反规定载人的"},
    {"value":"10363","label":"货运机动车违反规定载人的"},
    {"value":"10370","label":"未将故障车辆移到不妨碍交通的地方停放的"},
    {"value":"10380","label":"不避让正在作业的道路养护车、工程作业车的"},
    {"value":"10390","label":"机动车违反规定停放、临时停车且驾驶人不在现场或驾驶人虽在现场拒绝立即驶离，妨碍其他车辆、行人通行的"},
    {"value":"10400","label":"机动车喷涂、粘贴标识或者车身广告影响安全驾驶的"},
    {"value":"10410","label":"道路养护施工作业车辆、机械作业时未开启示警灯和危险报警闪光灯的"},
    {"value":"10430","label":"变更车道时影响正常行驶的机动车的"},
    {"value":"10440","label":"在禁止掉头或者禁止左转弯标志、标线的地点掉头的"},
    {"value":"10450","label":"在容易发生危险的路段掉头的"},
    {"value":"10460","label":"掉头时妨碍正常行驶的车辆和行人通行的"},
    {"value":"10470","label":"机动车未按规定鸣喇叭示意的"},
    {"value":"10480","label":"在禁止鸣喇叭的区域或者路段鸣喇叭的"},
    {"value":"10490","label":"在机动车驾驶室的前后窗范围内悬挂、放置妨碍驾驶人视线的物品的"},
    {"value":"10500","label":"机动车行经漫水路或漫水桥时未低速通过的"},
    {"value":"10510","label":"机动车载运超限物品行经铁路道口时不按指定的道口通过的"},
    {"value":"10520","label":"机动车载运超限物品行经铁路道口时不按指定的时间通过的"},
    {"value":"10530","label":"机动车行经渡口，不服从渡口管理人员指挥，不依次待渡的"},
    {"value":"10540","label":"上下渡船时，不低速慢行的"},
    {"value":"10550","label":"特种车辆违反规定使用警报器的"},
    {"value":"10560","label":"特种车辆违反规定使用标志灯具的"},
    {"value":"10570","label":"机动车在单位院内、居民居住区内不低速行驶的"},
    {"value":"10580","label":"机动车在单位院内居民居住区内不避让行人的"},
    {"value":"10590","label":"驾驶摩托车手离车把的"},
    {"value":"10600","label":"驾驶摩托车在车把上悬挂物品的"},
    {"value":"10610","label":"拖拉机驶入大中城市中心城区内道路的"},
    {"value":"10620","label":"拖拉机驶入其它禁止通行道路的"},
    {"value":"10630","label":"拖拉机载人的"},
    {"value":"10640","label":"拖拉机牵引多辆挂车的"},
    {"value":"10650","label":"学习驾驶人不按指定路线上道路学习驾驶的"},
    {"value":"10660","label":"学习驾驶人不按指定时间上道路学习驾驶的"},
    {"value":"10670","label":"学习驾驶人使用非教练车上道路驾驶的"},
    {"value":"10680","label":"学习驾驶人在教练不随车指导下上道路驾驶车辆的"},
    {"value":"10690","label":"使用教练车时有与教学无关的人员乘坐的"},
    {"value":"10700","label":"实习期内未粘贴或悬挂实习标志的"},
    {"value":"10720","label":"驾驶安全设施不全的机动车的"},
    {"value":"10730","label":"驾驶机件不符合技术标准的机动车的"},
    {"value":"10740","label":"不按规定倒车的"},
    {"value":"10750","label":"在车门、车厢没有关好时行车的"},
    {"value":"10760","label":"机动车在没有划分机动车道、非机动车道和人行道的道路上，不在道路中间通行的"},
    {"value":"10770","label":"驾驶机动车下陡坡时熄火、空档滑行的"},
    {"value":"10780","label":"机动车违反交通管制规定强行通行，不听劝阻的"},
    {"value":"10820","label":"使用他人机动车驾驶证驾驶机动车的"},
    {"value":"10830","label":"载货汽车、挂车未按照规定安装侧面及后下部防护装置的、粘贴车身反光标识的"},
    {"value":"10840","label":"改变车身颜色、更换发动机、车身或者车架，未按规定时限办理变更登记的"},
    {"value":"10850","label":"机动车所有权转移后，现机动车所有人未按规定时限办理转移登记的"},
    {"value":"10860","label":"机动车所有人办理变更登记、转移登记，机动车档案转出登记地车辆管理所后，未按照规定时限到住所地车辆管理所申请机动车转入的"},
    {"value":"10870","label":"擅自改变机动车外形和已登记的有关技术数据的"},
    {"value":"10880","label":"以欺骗、贿赂等不正当手段办理补、换领机动车登记证书、号牌、行驶证和检验合格标志等业务的"},
    {"value":"10890","label":"公路客运车辆违反规定载货的"},
    {"value":"10900","label":"机动车违反警告标志指示的"},
    {"value":"10910","label":"机动车违反警告标线指示的"},
    {"value":"10920","label":"公路客运车辆以外的载客汽车违反规定载货的"},
    {"value":"10930","label":"驾驶时观看电视的"},
    {"value":"10940","label":"在同车道行驶中，不按规定与前车保持必要的安全距离的"},
    {"value":"10950","label":"实习期内驾驶公共汽车的"},
    {"value":"10960","label":"实习期内驾驶营运客车的"},
    {"value":"10970","label":"实习期内驾驶执行任务的特种车辆的"},
    {"value":"10980","label":"实习期内驾驶载有危险物品的机动车的"},
    {"value":"10990","label":"实习期内驾驶机动车牵引挂车的"},
    {"value":"11020","label":"不按规定使用灯光的"},
    {"value":"11030","label":"不按规定会车的"},
    {"value":"11080","label":"上道路行驶的机动车未放置保险标志的"},
    {"value":"11090","label":"未随车携带行驶证的"},
    {"value":"11100","label":"未随车携带驾驶证的"},
    {"value":"11110","label":"机动车载货长度、宽度、高度超过规定的"},
    {"value":"11150","label":"上道路行驶的机动车未放置检验合格标志的"},
    {"value":"12070","label":"驾驶摩托车时驾驶人未按规定戴安全头盔的"},
    {"value":"12080","label":"机动车通过有灯控路口时，不按所需行进方向驶入导向车道的"},
    {"value":"12090","label":"左转弯时，未靠路口中心点左侧转弯的"},
    {"value":"12100","label":"通过路口遇放行信号不依次通过的"},
    {"value":"12110","label":"通过路口遇停止信号时，停在停止线以内或路口内的"},
    {"value":"12120","label":"通过路口向右转弯遇同车道内有车等候放行信号时，不依次停车等候的"},
    {"value":"12230","label":"驾驶时拨打接听手持电话的"},
    {"value":"12250","label":"驾车时有其他妨碍安全行车的行为的"},
    {"value":"12280","label":"路口遇有交通阻塞时未依次等候的"},
    {"value":"12430","label":"遇前方机动车停车排队或者缓慢行驶时，借道超车或者占用对面车道、穿插等候车辆的"},
    {"value":"12440","label":"在城市快速道上行驶时，驾驶人未按规定使用安全带的"},
    {"value":"12450","label":"不按照规定为校车配备安全设备的"},
    {"value":"12460","label":"不按照规定对校车进行安全维护的"},
    {"value":"12470","label":"驾驶校车运载学生，不按照规定放置校车标牌的"},
    {"value":"12480","label":"驾驶校车运载学生，不按照规定开启校车标志灯的"},
    {"value":"12490","label":"驾驶校车运载学生，不按照经审核确定线路行驶的"},
    {"value":"12500","label":"校车上下学生，不按照规定在校车停靠站点停靠的"},
    {"value":"12510","label":"校车未运载学生上道路行驶，使用校车标牌的"},
    {"value":"12520","label":"校车未运载学生上道路行驶，使用校车标志灯的"},
    {"value":"12530","label":"校车未运载学生上道路行驶，使用停车指示标志的"},
    {"value":"12540","label":"驾驶校车上道路行驶前，未对校车车况是否符合安全技术要求进行检查的"},
    {"value":"12550","label":"驾驶存在安全隐患的校车上道路行驶的"},
    {"value":"12560","label":"在校车载有学生时给车辆加油的"},
    {"value":"12570","label":"在校车发动机引擎熄灭前离开驾驶座位的"},
    {"value":"13010","label":"机动车逆向行驶的"},
    {"value":"13040","label":"从前车右侧超车的"},
    {"value":"13050","label":"前车左转弯时超车的"},
    {"value":"13060","label":"前车掉头时超车的"},
    {"value":"13070","label":"前车超车时超车的"},
    {"value":"13080","label":"与对面来车有会车可能时超车的"},
    {"value":"13090","label":"超越执行紧急任务的警车、消防车、救护车、工程救险车的"},
    {"value":"13100","label":"在铁路道口、路口、窄桥、弯道、陡坡、隧道、人行横道、交通流量大的路段等地点超车的"},
    {"value":"13110","label":"车辆在道路上发生故障或事故后，妨碍交通又难以移动的，不按规定设置警告标志或未按规定使用警示灯光的"},
    {"value":"13120","label":"准备进入环形路口不让已在路口内的机动车先行的"},
    {"value":"13130","label":"转弯的机动车未让直行的车辆、行人先行的"},
    {"value":"13140","label":"相对方向行驶的右转弯机动车不让左转弯车辆先行的"},
    {"value":"13150","label":"机动车通过无灯控或交警指挥的路口，不按交通标志、标线指示让优先通行的一方先行的"},
    {"value":"13160","label":"机动车通过无灯控、交警指挥、交通标志标线控制的路口，不让右方道路的来车先行的"},
    {"value":"13170","label":"载货汽车牵引多辆挂车的"},
    {"value":"13180","label":"半挂牵引车牵引多辆挂车的"},
    {"value":"13200","label":"小型载客汽车牵引旅居挂车以外的且总质量700千克以上挂车的"},
    {"value":"13220","label":"载货汽车牵引挂车的载质量超过汽车本身的载质量的"},
    {"value":"13230","label":"大型载客汽车牵引挂车的"},
    {"value":"13240","label":"中型载客汽车牵引挂车的"},
    {"value":"13250","label":"低速载货汽车牵引挂车的"},
    {"value":"13260","label":"三轮汽车牵引挂车的"},
    {"value":"13270","label":"机动车在发生故障或事故后，不按规定使用灯光的"},
    {"value":"13330","label":"不避让执行任务的特种车辆的"},
    {"value":"13340","label":"机动车不避让盲人的"},
    {"value":"13400","label":"机动车未按照规定期限进行安全技术检验的"},
    {"value":"13440","label":"机动车违反禁令标志指示的"},
    {"value":"13450","label":"机动车违反禁止标线指示的"},
    {"value":"13480","label":"驾驶营运客车（不包括公共汽车）、校车以外的载客汽车载人超过核定人数未达20%的"},
    {"value":"13490","label":"驾驶中型以上载客汽车在高速公路、城市快速路以外的道路上行驶超过规定时速未达20%的"},
    {"value":"13500","label":"驾驶中型以上载货汽车在高速公路、城市快速路以外的道路上行驶超过规定时速未达20%的"},
    {"value":"13510","label":"驾驶危险物品运输车辆在高速公路、城市快速路以外的道路上行驶超过规定时速未达20%的"},
    {"value":"13520","label":"驾驶中型以上载客载货汽车、危险物品运输车辆以外的其他机动车在高速公路以外的道路行驶超过规定时速未达20%的"},
    {"value":"13524","label":"驾驶中型以上载客载货汽车、危险物品运输车辆以外的其他机动车在高速公路上行驶超过规定时速未达20%的"},
    {"value":"13530","label":"驾驶货车载物超过核定载质量未达30%的"},
    {"value":"13540","label":"驾驶危险物品运输车辆载物超过核定载质量未达30%的"},
    {"value":"13550","label":"驾驶机动车在城市快速路上不按规定车道行驶的"},
    {"value":"13560","label":"行经人行横道，未减速行驶的"},
    {"value":"13570","label":"遇行人正在通过人行横道时未停车让行的"},
    {"value":"13580","label":"行经没有交通信号的道路时，遇行人横过道路未避让的"},
    {"value":"16101","label":"在驾驶证暂扣期间仍驾驶机动车的"},
    {"value":"16102","label":"在驾驶证暂扣期间仍驾驶机动车的"},
    {"value":"16103","label":"在驾驶证暂扣期间仍驾驶机动车的"},
    {"value":"16104","label":"在驾驶证暂扣期间仍驾驶机动车的"},
    {"value":"16170","label":"运载危险物品时不按规定的时间、路线、速度行驶的"},
    {"value":"16180","label":"运载危险物品时未悬挂警示标志的"},
    {"value":"16190","label":"运载危险物品时未采取必要的安全措施的"},
    {"value":"16210","label":"公路客运车辆载客超过核定乘员20%以内的"},
    {"value":"16220","label":"机动车在城市快速路上遇交通拥堵，占用应急车道行驶的"},
    {"value":"16230","label":"校车载人超过核定人数未达20%的"},
    {"value":"16240","label":"机动车驾驶人不按照规定避让校车的"},
    {"value":"16250","label":"驾驶机动车违反道路交通信号灯通行的"},
    {"value":"16260","label":"驾驶公路客运车辆、公共汽车以外的其他营运客车载人超过核定人数未达20％的"},
    {"value":"16270","label":"驾驶营运客车（不包括公共汽车）以外的其他载客汽车载人超过核定人数20％以上的"},
    {"value":"16280","label":"驾驶中型以上载客汽车在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"16290","label":"驾驶中型以上载货汽车在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"16300","label":"驾驶校车在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"16310","label":"驾驶危险物品运输车辆在城市快速路上行驶超过规定时速未达20％的"},
    {"value":"16326","label":"驾驶中型以上载客汽车在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到30%的"},
    {"value":"16327","label":"驾驶中型以上载客汽车在高速公路、城市快速路以外的道路上行驶超过规定时速30%以上未达到50%的"},
    {"value":"16336","label":"驾驶中型以上载货汽车在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到30%的"},
    {"value":"16337","label":"驾驶中型以上载货汽车在高速公路、城市快速路以外的道路上行驶超过规定时速30%以上未达到50%的"},
    {"value":"16346","label":"驾驶校车在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到30%的"},
    {"value":"16347","label":"驾驶校车在高速公路、城市快速路以外的道路上行驶超过规定时速30%以上未达到50%的"},
    {"value":"16356","label":"驾驶危险物品运输车辆在高速公路、城市快速路以外的道路上行驶超过规定时速20%以上未达到30%的"},
    {"value":"16357","label":"驾驶危险物品运输车辆在高速公路、城市快速路以外的道路上行驶超过规定时速30%以上未达到50%的"},
    {"value":"16366","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的其他机动车在高速公路以外的道路上行驶超过规定时速20%以上未达到30%的"},
    {"value":"16367","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的其他机动车在高速公路以外的道路上行驶超过规定时速30%以上未达到50%的"},
    {"value":"16364","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的其他机动车在高速公路行驶超过规定时速20%以上未达到50%的"},
    {"value":"16372","label":"驾驶货车载物超过核定载质量50%以上不足100%的"},
    {"value":"16373","label":"驾驶货车载物超过核定载质量100%的"},
    {"value":"16375","label":"驾驶货车载物超过核定载质量30%以上不足50%的"},
    {"value":"16376","label":"机动车载物超过核定载质量50%以上不足100%的"},
    {"value":"16377","label":"驾驶货车载物超过核定载质量100%的"},
    {"value":"16380","label":"驾驶货车违反规定载客的"},
    {"value":"16383","label":"货运机动车违反规定载客的"},
    {"value":"16390","label":"危险物品运输车辆载物超过核定载质量30%以上的"},
    {"value":"16400","label":"驾驶机动车运载超限的不可解体的物品，未按指定的时间、路线、速度行驶的"},
    {"value":"16410","label":"驾驶机动车运载超限的不可解体的物品，未悬挂明显标志的"},
    {"value":"16420","label":"连续驾驶中型以上载客汽车、危险物品运输车辆以外的机动车超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"17129","label":"饮酒后驾驶机动车的"},
    {"value":"17050","label":"造成交通事故后逃逸，尚不构成犯罪的"},
    {"value":"17091","label":"驾驶与驾驶证载明的准驾车型不相符合的车辆的"},
    {"value":"17092","label":"驾驶与驾驶证载明的准驾车型不相符合的车辆的"},
    {"value":"17093","label":"驾驶与驾驶证载明的准驾车型不相符合的车辆的"},
    {"value":"17094","label":"驾驶与驾驶证载明的准驾车型不相符合的车辆的"},
    {"value":"17105","label":"公路客运车辆载客超过额定乘员20%不足50%的"},
    {"value":"17106","label":"公路客运车辆载客超过额定乘员50%的"},
    {"value":"17140","label":"校车载人超过核定人数20%以上的"},
    {"value":"17150","label":"驾驶人未取得校车驾驶资格驾驶校车的"},
    {"value":"17160","label":"驾驶公路客运车辆、公共汽车以外的其他营运客车载人超过核定人数20%以上"},
    {"value":"17170","label":"上道路行驶的机动车未悬挂机动车号牌的"},
    {"value":"17180","label":"故意遮挡机动车号牌的"},
    {"value":"17190","label":"故意污损机动车号牌的"},
    {"value":"17200","label":"不按规定安装机动车号牌的"},
    {"value":"17214","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的机动车在高速公路上行驶超过规定时速50%的"},
    {"value":"17215","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的机动车在高速公路以外的道路行驶超过规定时速50%不足70%的"},
    {"value":"17216","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的机动车在高速公路以外的道路行驶超过规定时速70%不足100%的"},
    {"value":"17217","label":"驾驶中型以上载客载货汽车、校车、危险物品运输车辆以外的机动车在高速公路以外的道路行驶超过规定时速100%的"},
    {"value":"17226","label":"驾驶中型以上载客汽车在城市快速路上行驶超过规定时速20％以上未达30%的"},
    {"value":"17227","label":"驾驶中型以上载客汽车在城市快速路上行驶超过规定时速30％以上未达50%的"},
    {"value":"17236","label":"驾驶中型以上载货汽车在城市快速路上行驶超过规定时速20％以上未达30%的"},
    {"value":"17237","label":"驾驶中型以上载货汽车在城市快速路上行驶超过规定时速30％以上未达50%的"},
    {"value":"17246","label":"驾驶校车在城市快速路上行驶超过规定时速20％以上未达30%的"},
    {"value":"17247","label":"驾驶校车在城市快速路上行驶超过规定时速30％以上未达50%的"},
    {"value":"17250","label":"驾驶危险物品运输车辆在城市快速路上行驶超过规定时速20％以上未达50%的"},
    {"value":"17265","label":"驾驶中型以上载客汽车在高速公路以外的道路上行驶超过规定时速50%不足70%的"},
    {"value":"17266","label":"驾驶中型以上载客汽车在高速公路以外的道路上行驶超过规定时速70%不足100%的"},
    {"value":"17267","label":"驾驶中型以上载客汽车在高速公路以外的道路上行驶超过规定时速100%的"},
    {"value":"17275","label":"驾驶中型以上载货汽车在高速公路以外的道路上行驶超过规定时速50%不足70%的"},
    {"value":"17276","label":"驾驶中型以上载货汽车在高速公路以外的道路上行驶超过规定时速70%不足100%的"},
    {"value":"17277","label":"驾驶中型以上载货汽车在高速公路以外的道路上行驶超过规定时速100%的"},
    {"value":"17285","label":"驾驶校车在高速公路以外的道路上行驶超过规定时速50%不足70%的"},
    {"value":"17286","label":"驾驶校车在高速公路以外的道路上行驶超过规定时速70%不足100%的"},
    {"value":"17287","label":"驾驶校车在高速公路以外的道路上行驶超过规定时速100%的"},
    {"value":"17295","label":"驾驶危险物品运输车辆在高速公路以外的道路上行驶超过规定时速50%不足70%的"},
    {"value":"17296","label":"驾驶危险物品运输车辆在高速公路以外的道路上行驶超过规定时速70%不足100%的"},
    {"value":"17297","label":"驾驶危险物品运输车辆在高速公路以外的道路上行驶超过规定时速100%的"},
    {"value":"17300","label":"连续驾驶中型以上载客汽车超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"17310","label":"连续驾驶危险物品运输车辆超过4小时未停车休息或者停车休息时间少于20分钟的"},
    {"value":"60010","label":"牵引故障机动车时，被牵引的机动车除驾驶人外载人的"},
    {"value":"60020","label":"牵引故障机动车时，被牵引的机动车拖带挂车的"},
    {"value":"60030","label":"牵引故障机动车时，被牵引的机动车宽度大于牵引的机动车的"},
    {"value":"60040","label":"使用软连接装置牵引故障机动车时，牵引车与被牵引车之间未保持安全距离的"},
    {"value":"60050","label":"牵引制动失效的被牵引车，未使用硬连接牵引装置的"},
    {"value":"60060","label":"使用汽车吊车牵引车辆的"},
    {"value":"60070","label":"使用轮式专用机械牵引车辆的"},
    {"value":"60080","label":"使用摩托车牵引车辆的"},
    {"value":"60090","label":"牵引摩托车的"},
    {"value":"60100","label":"未使用专用清障车拖曳转向或照明、信号装置失效的机动车的"},
    {"value":"null","label":"在高速公路或城市快速路以外的道路上行驶时，驾驶人未按规定使用安全带的"},
    {"value":"60110","label":"null"},
    {"value":"60120","label":"摩托车后座乘坐不满十二周岁未成年人的"},
    {"value":"60130","label":"驾驶轻便摩托车载人的"},
    {"value":"60140","label":"机动车载物行驶时遗洒、飘散载运物的"},
    {"value":"60150","label":"运载超限物品时不按规定的时间、路线、速度行驶的"},
    {"value":"60160","label":"运载超限物品时未悬挂明显标志的"},
    {"value":"60180","label":"补领机动车驾驶证后，继续使用原机动车驾驶证的"},
    {"value":"60190","label":"发生交通事故后，应当自行撤离现场而未撤离，造成交通堵塞的"},
    {"value":"60200","label":"驾驶拼装的机动车接送学生的"},
    {"value":"60210","label":"驾驶达到报废标准的机动车接送学生的"},
    {"value":"60220","label":"饮酒或醉酒后驾驶机动车发生重大交通事故，构成犯罪的"},
    {"value":"60230","label":"驾驶机动车在高速公路、城市快速路以外的道路上不按规定车道行驶的"},
    {"value":"60240","label":"机动车驾驶人在实习期内驾驶公共汽车、营运客车或者执行任务的警车、消防车、救护车、工程救险车以及载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车的"},
    {"value":"60250","label":"机动车驾驶人在实习期内驾驶牵引挂车的"},
    {"value":"60260","label":"机动车驾驶人在实习期内驾驶机动车上高速公路行驶，无相应或者更高准驾车型驾驶证三年以上的驾驶人陪同的"},
    {"value":"60270","label":"驾驶机动车未按规定粘贴、悬挂实习标志的"},
    {"value":"60280","label":"驾驶机动车未按规定粘贴、悬挂残疾人机动车专用标志的"},
    {"value":"60290","label":"持有大型客车、牵引车、城市公交车、中型客车、大型货车驾驶证的驾驶人，未按照规定申报变更信息的"},
    {"value":"60300","label":"机动车驾驶人身体条件发生变化不适合驾驶机动车，仍驾驶机动车的"},
    {"value":"60310","label":"逾期不参加审验仍驾驶机动车的"},
    {"value":"60320","label":"醉酒后驾驶机动车的"},
    {"value":"60330","label":"醉酒后驾驶营运机动车的"},
    {"value":"60340","label":"饮酒后驾驶营运机动车的"},
    {"value":"60350","label":"因饮酒后驾驶机动车被处罚，再次饮酒后驾驶机动车的"},
    {"value":"60360","label":"挂车的灯光信号、制动、连接、安全防护等装置不符合国家标准的"},
    {"value":"60370","label":"挂车载人的"},
    {"value":"60380","label":"货运机动车驾驶室载人超过核定人数的"},
    {"value":"20010","label":"非机动车造成交通事故后逃逸，尚不构成犯罪的"},
    {"value":"20020","label":"非机动车违反交通管制的规定强行通行，不听劝阻的"},
    {"value":"20030","label":"非机动车未依法登记，上道路行驶的"},
    {"value":"20040","label":"非机动车逆向行驶的"},
    {"value":"20050","label":"没有非机动车道的道路上，非机动车不靠车行道右侧行驶的"},
    {"value":"20060","label":"非机动车违反规定使用其他车辆专用车道的"},
    {"value":"20070","label":"非机动车不按照交通信号规定通行的"},
    {"value":"20080","label":"非机动车驾驶人不服从交警指挥的"},
    {"value":"20090","label":"非机动车未在非机动车道内行驶的"},
    {"value":"20100","label":"醉酒驾驶、驾驭非机动车、畜力车的"},
    {"value":"20110","label":"驾驶残疾人机动轮椅车超速行驶的"},
    {"value":"20120","label":"驾驶电动自行车超速行驶的"},
    {"value":"20130","label":"非机动车不按规定载物（人）的"},
    {"value":"20140","label":"非机动车不在规定地点停放的"},
    {"value":"20150","label":"非机动车停放时妨碍其他车辆和行人通行的"},
    {"value":"20160","label":"非机动车通过路口，转弯的非机动车不让直行的车辆、行人优先通行的"},
    {"value":"20170","label":"非机动车通过路口，遇有前方路口交通阻塞时，强行进入的"},
    {"value":"20180","label":"非机动车通过路口，向左转弯时，不靠路口中心点右侧转弯的"},
    {"value":"20190","label":"非机动车遇停止信号时，停在停止线以内或路口内的"},
    {"value":"20200","label":"非机动车向右转弯遇同车道内有车等候放行信号不能转弯时，不依次等候的"},
    {"value":"20210","label":"行经无灯控或交警指挥的路口，不让标志、标线指示优先通行的一方先行的"},
    {"value":"20220","label":"行经无灯控、交警指挥或标志、标线控制的路口，无交通标志标线，不让右方道路的来车先行的"},
    {"value":"20230","label":"行经无灯控或交警指挥的路口，右转弯的非机动车不让左转弯的车辆先行的"},
    {"value":"20240","label":"驾驶自行车、电动自行车、三轮车在路段上横过机动车道时不下车推行的"},
    {"value":"20250","label":"有人行横道时，非机动车不从人行横道横过机动车道的"},
    {"value":"20260","label":"有行人过街设施时，非机动车不从行人过街设施横过机动车道的"},
    {"value":"20270","label":"非机动车借道行驶后不迅速驶回非机动车道的"},
    {"value":"20280","label":"非机动车转弯时未减速慢行，伸手示意，突然猛拐的"},
    {"value":"20290","label":"非机动车超车时妨碍被超越的车辆行驶的"},
    {"value":"20300","label":"驾驶非机动车牵引车辆的"},
    {"value":"20310","label":"驾驶非机动车攀扶车辆的"},
    {"value":"20320","label":"非机动车被其他车辆牵引的"},
    {"value":"20330","label":"驾驶非机动车时双手离把的"},
    {"value":"20340","label":"驾驶非机动车时手中持物的"},
    {"value":"20350","label":"驾驶非机动车时扶身并行的"},
    {"value":"20360","label":"驾驶非机动车时互相追逐的"},
    {"value":"20370","label":"驾驶非机动车时曲折竞驶的"},
    {"value":"20380","label":"在道路上骑独轮自行车的"},
    {"value":"20390","label":"在道路上骑2人以上骑行的自行车的"},
    {"value":"20400","label":"非下肢残疾的人驾驶残疾人机动轮椅车的"},
    {"value":"20410","label":"自行车加装动力装置的"},
    {"value":"20420","label":"三轮车加装动力装置的"},
    {"value":"20430","label":"在道路上学习驾驶非机动车的"},
    {"value":"20440","label":"非机动车不避让盲人的"},
    {"value":"20450","label":"驾驭畜力车横过道路时，驾驭人未下车牵引牲畜的"},
    {"value":"20460","label":"畜力车并行的"},
    {"value":"20470","label":"驾驶畜力车时驾驭人离开车辆的"},
    {"value":"20480","label":"驾驶畜力车时在容易发生危险的路段超车的"},
    {"value":"20490","label":"驾驶两轮畜力车不下车牵引牲畜的"},
    {"value":"20500","label":"使用未经驯服的牲畜驾车的"},
    {"value":"20510","label":"随车幼畜未栓系的"},
    {"value":"20520","label":"停放畜力车时未拉紧车闸的"},
    {"value":"20530","label":"停放畜力车时未栓系牲畜的"},
    {"value":"20540","label":"未满12周岁驾驶自行车、三轮车的"},
    {"value":"20550","label":"未满16周岁驾驶、驾驭电动自行车、残疾人机动轮椅、畜力车的"},
    {"value":"30010","label":"行人违反交通信号通行的"},
    {"value":"30020","label":"行人不服从交警指挥的"},
    {"value":"30030","label":"行人不在人行道内行走的"},
    {"value":"30040","label":"行人在没有划分机动车道、非机动车道和人行道的道路上，不靠路边行走的"},
    {"value":"30050","label":"行人横过道路未走人行横道或过街设施的"},
    {"value":"30060","label":"行人跨越道路隔离设施的"},
    {"value":"30070","label":"行人倚坐道路隔离设施的"},
    {"value":"30080","label":"行人扒车的"},
    {"value":"30090","label":"行人强行拦车的"},
    {"value":"30100","label":"行人实施其他妨碍交通安全的行为的"},
    {"value":"30110","label":"学龄前儿童以及不能辨认或不能控制自己行为的精神疾病患者、智力障碍者在道路上通行时，没有其监护人或对其负有管理职责的人带领的"},
    {"value":"30120","label":"盲人在道路上通行，未使用导盲手段的"},
    {"value":"30130","label":"行人不按规定通过铁路道口的"},
    {"value":"30140","label":"在道路上使用滑行工具的"},
    {"value":"30150","label":"行人在车行道内坐卧、停留、嬉闹的"},
    {"value":"30160","label":"行人有追车、抛物击车等妨碍道路交通安全的行为的"},
    {"value":"30170","label":"行人不按规定横过机动车道的"},
    {"value":"30180","label":"行人列队在道路上通行时每横列超过2人的"},
    {"value":"30190","label":"机动车行驶时，乘坐人员未按规定使用安全带的"},
    {"value":"30200","label":"乘坐摩托车不戴安全头盔的"},
    {"value":"30210","label":"乘车人携带易燃、易爆等危险物品的"},
    {"value":"30220","label":"乘车人向车外抛洒物品的"},
    {"value":"30230","label":"乘车人有影响驾驶人安全驾驶的行为的"},
    {"value":"30240","label":"在机动车道上拦乘机动车的"},
    {"value":"30250","label":"在机动车道上从机动车左侧上下车的"},
    {"value":"30260","label":"开关车门妨碍其他车辆和行人通行的"},
    {"value":"30270","label":"机动车行驶中乘坐人员干扰驾驶的"},
    {"value":"30280","label":"机动车行驶中乘坐人员将身体任何部分伸出车外的"},
    {"value":"30290","label":"乘车人在机动车行驶中跳车的"},
    {"value":"30300","label":"乘坐两轮摩托车未正向骑坐的"},
    {"value":"40010","label":"行人进入高速公路的"},
    {"value":"40020","label":"驾驶禁止进入高速公路的机动车驶入高速公路的"},
    {"value":"40030","label":"非机动车进入高速公路的"},
    {"value":"40040","label":"在高速公路上车辆发生故障或事故后，车上人员未迅速转移到右侧路肩上或者应急车道内的"},
    {"value":"40050","label":"机动车从匝道进入或驶离高速公路时不按规定使用灯光的"},
    {"value":"40060","label":"机动车从匝道进入高速公路时妨碍已在高速公路内的机动车正常行驶的"},
    {"value":"40070","label":"在高速公路的路肩上行驶的"},
    {"value":"40080","label":"非紧急情况下在高速公路应急车道上行驶的"},
    {"value":"40090","label":"机动车在高速公路上通过施工作业路段，不减速行驶的"},
    {"value":"40100","label":"在高速公路上骑、轧车行道分界线的"},
    {"value":"40110","label":"在高速公路上试车或学习驾驶机动车的"},
    {"value":"40120","label":"在高速公路上违反规定拖曳故障车、肇事车的"},
    {"value":"40140","label":"在高速公路上行驶的载货汽车车厢载人的"},
    {"value":"40150","label":"在高速公路上行驶的两轮摩托车载人的"},
    {"value":"42040","label":"在高速公路上行驶时，驾驶人未按规定使用安全带的"},
    {"value":"43010","label":"驾驶设计最高时速低于70公里的机动车进入高速公路的"},
    {"value":"43020","label":"机动车在高速公路上发生故障或交通事故后，驾驶人不按规定使用危险报警闪光灯的"},
    {"value":"43030","label":"高速公路上车辆发生故障或交通事故后，不按规定设置警告标志的"},
    {"value":"43060","label":"在高速公路上正常情况下以低于规定最低时速行驶的"},
    {"value":"43110","label":"在高速公路上不按规定超车的"},
    {"value":"43120","label":"驾驶机动车在高速公路上不按规定车道行驶的"},
    {"value":"46080","label":"机动车在高速公路遇交通拥堵，占用应急车道行驶的"},
    {"value":"46090","label":"驾驶中型以上载客汽车在高速公路上行驶超过规定时速未达20％的"},
    {"value":"46100","label":"驾驶中型以上载货汽车在高速公路上行驶超过规定时速未达20％的"},
    {"value":"46110","label":"驾驶校车在高速公路上行驶超过规定时速未达20％的"},
    {"value":"46120","label":"驾驶危险物品运输车辆在高速公路上行驶超过规定时速未达20％的"},
    {"value":"46130","label":"驾驶营运客车以外的机动车在高速公路行车道上停车的"},
    {"value":"46140","label":"驾驶营运客车以外的机动车非紧急情况下在高速公路应急车道上停车的"},
    {"value":"46150","label":"低能见度气象条件下，驾驶机动车在高速公路上不按规定行驶的"},
    {"value":"47010","label":"在高速公路上倒车的"},
    {"value":"47020","label":"在高速公路上逆行的"},
    {"value":"47030","label":"在高速公路上穿越中央分隔带掉头的"},
    {"value":"47040","label":"驾驶营运客车在高速公路行车道上停车的"},
    {"value":"47050","label":"驾驶营运客车非紧急情况下在高速公路应急车道上停车的"},
    {"value":"47060","label":"驾驶中型以上载客汽车在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"47070","label":"驾驶中型以上载货汽车在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"47080","label":"驾驶校车在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"47090","label":"驾驶危险物品运输车辆在高速公路上行驶超过规定时速20％以上未达50%的"},
    {"value":"47100","label":"驾驶中型以上载客汽车在高速公路上行驶超过规定时速50%的"},
    {"value":"47110","label":"驾驶中型以上载货汽车在高速公路上行驶超过规定时速50%的"},
    {"value":"47120","label":"驾驶校车在高速公路上行驶超过规定时速50%的"},
    {"value":"47130","label":"驾驶危险物品运输车辆在高速公路上行驶超过规定时速50%的"},
    {"value":"50019","label":"伪造、变造机动车登记证书的"},
    {"value":"50029","label":"伪造、变造机动车号牌的"},
    {"value":"50039","label":"伪造、变造机动车行驶证的"},
    {"value":"50049","label":"伪造、变造机动车检验合格标志的"},
    {"value":"50059","label":"伪造、变造机动车保险标志的"},
    {"value":"50069","label":"伪造、变造机动车驾驶证的"},
    {"value":"50079","label":"使用伪造、变造的机动车登记证书的"},
    {"value":"50109","label":"使用伪造、变造的机动车检验合格标志的"},
    {"value":"50119","label":"使用伪造、变造的机动车保险标志的"},
    {"value":"50139","label":"使用其他车辆的机动车登记证书的"},
    {"value":"50169","label":"使用其他车辆的机动车检验合格标志的"},
    {"value":"50179","label":"使用其他车辆的机动车保险标志的"},
    {"value":"50180","label":"强迫驾驶人违反交通安全法律、法规和安全驾驶要求驾驶机动车，造成交通事故但尚不构成犯罪的"},
    {"value":"50190","label":"故意损毁交通设施，造成危害后果，尚不构成犯罪的"},
    {"value":"50200","label":"故意移动交通设施，造成危害后果，尚不构成犯罪的"},
    {"value":"50210","label":"故意涂改交通设施，造成危害后果，尚不构成犯罪的"},
    {"value":"50220","label":"非法拦载机动车，不听劝阻，造成交通严重阻塞、较大财产损失的"},
    {"value":"50230","label":"非法扣留机动车辆，不听劝阻，造成交通严重阻塞、较大财产损失的"},
    {"value":"50240","label":"道路两侧及隔离带上种植物或设置广告牌、管线等，遮挡路灯、交通信号灯、交通标志，妨碍安全视距拒不排除障碍的"},
    {"value":"50250","label":"道路两侧及隔离带上种植物或设置广告牌、管线等，遮挡路灯、交通信号灯、交通标志，妨碍安全视距的"},
    {"value":"50260","label":"擅自挖掘道路影响交通安全的"},
    {"value":"50270","label":"擅自占用道路施工影响交通安全的"},
    {"value":"50280","label":"从事其他影响交通安全活动的"},
    {"value":"50290","label":"出售已达到报废标准的机动车的"},
    {"value":"50300","label":"非特种车喷涂特种车特定标志图案的"},
    {"value":"50310","label":"生产拼装机动车的"},
    {"value":"50320","label":"生产擅自改装的机动车的"},
    {"value":"50330","label":"销售拼装机动车的"},
    {"value":"50340","label":"销售擅自改装的机动车的"},
    {"value":"50350","label":"服用国家管制的精神药品或麻醉药品仍继续驾驶的"},
    {"value":"50360","label":"患有妨碍安全驾驶机动车的疾病仍继续驾驶的"},
    {"value":"50370","label":"过度疲劳仍继续驾驶的"},
    {"value":"50380","label":"重型、中型载货汽车及其挂车的车身或者车厢后部未按照规定喷涂放大的牌号或者放大的牌号不清晰的"},
    {"value":"50390","label":"对符合暂扣和吊销机动车驾驶证情形，机动车驾驶证被扣留后驾驶人无正当理由逾期未接受处理的"},
    {"value":"50400","label":"以欺骗、贿赂手段取得机动车牌证的"},
    {"value":"50410","label":"以欺骗、贿赂手段取得驾驶证的"},
    {"value":"50420","label":"12个月内累积记分达到12分拒不参加学习也不接受考试的"},
    {"value":"50430","label":"车辆被扣留后，经公告三个月后仍不来接受处理的"},
    {"value":"50440","label":"机动车安全技术检验机构出具虚假检验结果的"},
    {"value":"50450","label":"擅自停止使用停车场或改作他用的"},
    {"value":"50460","label":"运输单位的客运车辆载客或货运车辆超载，经处罚不改的(对直接负责的主管人员)"},
    {"value":"50470","label":"改变机动车型号、发动机号、车架号或者车辆识别代号的"},
    {"value":"50480","label":"未经许可，占用道路从事非交通活动的"},
    {"value":"50500","label":"车辆所有人使用拼装的机动车接送学生的"},
    {"value":"50510","label":"车辆所有人使用达到报废标准的机动车接送学生的"},
    {"value":"50520","label":"使用未取得校车标牌的车辆提供校车服务的"},
    {"value":"50530","label":"使用未取得校车驾驶资格的人员驾驶校车的"},
    {"value":"50540","label":"伪造、变造校车标牌的"},
    {"value":"50550","label":"未按照规定指派照管人员随校车全程照管乘车学生的"},
    {"value":"50560","label":"在一个记分周期内累积记分达到12分的"},
    {"value":"56030","label":"采用隐瞒、欺骗手段补领机动车驾驶证的"},
    {"value":"57019","label":"使用伪造、变造的机动车号牌的"},
    {"value":"57029","label":"使用伪造、变造的机动车行驶证的"},
    {"value":"57039","label":"使用伪造、变造的机动车驾驶证的"},
    {"value":"57049","label":"使用其他车辆的机动车号牌的"},
    {"value":"57059","label":"使用其他车辆的机动车行驶证的"},
    {"value":"57060","label":"使用伪造、变造的校车标牌的"}
]